
<div>
  <div class="ui segment">
    <div class="ui top attached large label">地域から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="three wide column" style="padding-top: 0">
        <a :href="'/shops/search?prefecture=' + prefecture.value">{{ prefecture.label }}</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">忘年会・新年会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/enkai/'">{{ prefecture.label }}の忘年会・新年会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">懇親会・パーティー会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/konshinkai/'">{{ prefecture.label }}の懇親会・パーティー会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">歓迎会・送別会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/kansoukai/'">{{ prefecture.label }}の歓迎会・送別会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">企業パーティー会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/party/'">{{ prefecture.label }}の企業パーティー会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">謝恩会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/shaonkai/'">{{ prefecture.label }}の謝恩会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">同窓会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/dousoukai/'">{{ prefecture.label }}の同窓会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">二次会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/nijikai/'">{{ prefecture.label }}の二次会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">結婚式二次会会場から探す</div>
    <div class="ui stackable grid">
      <div v-for="prefecture in consts.SHOP_PREFECTURE" class="five wide column" style="padding-top: 0">
        <a :href="'/'+ prefecture.value + '/wedding_nijikai/'">{{ prefecture.label }}の結婚式二次会会場</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">会場の種類から探す</div>
    <div class="ui stackable grid">
      <div v-for="each in consts.SHOP_TYPE" class="five wide column" style="padding-top: 0">
        <a :href="'/shops/search?shop_types=' + each.value">{{ each.label }}</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">人数から探す</div>
    <div class="ui stackable grid">
      <div v-for="people in [20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 300]" class="three wide column" style="padding-top: 0">
        <a :href="'/shops/search?people_from=' + people">{{ people }}人〜</a>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui top attached large label">予算から探す</div>
    <div class="ui stackable grid">
      <div v-for="price in [3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000]" class="three wide column" style="padding-top: 0">
        <a :href="'/shops/search?price_to=' + price">〜{{ price | formatCurrency }}円</a>
      </div>
      <div class="three wide column" style="padding-top: 0">
        <a href="/shops/search?price_from=10000">10,000円〜</a>
      </div>
    </div>
  </div>
</div>
